export default __webpack_public_path__ + "static/9_33-e7501fa276a3414ada238682beb7a0b6.png";